<template>
  <div
    v-if="threeSixtyImage"
    class="three-sixty-image"
  >
    <ClientOnly>
      <VueThreeSixty
        :amount="threeSixtyImage.numberOfImages"
        :image-path="IMAGES_360_URL"
        :file-name="threeSixtyImage.path"
        :autoplay="true"
        :spin-reverse="true"
        :disable-scroll-event="true"
        :loop="1"
      />
    </ClientOnly>
  </div>
</template>

<script lang="ts">

import type { Product360Image } from '~~/types/product/Product360Image';

export default defineComponent({
  name: 'ThreeSixtyImage',
  props: {
    threeSixtyImage: {
      type: Object as PropType<Product360Image>,
      required: true,
    },
  },
  setup() {

    const { public: { IMAGES_360_URL } } = useRuntimeConfig();

    return { IMAGES_360_URL };
  
  },
});


</script>

<style lang="scss" scoped>
.three-sixty-image:deep(*) {
  .v360-menu-btns:has(.fa-hand-paper) {
    display: none;
  }

  .v360-navigate-btns {
    white-space: nowrap;
  }

  .v360-viewer-container {
    position: relative;
  }

  .v360-viewer-container::before {
    content: '';
    position: absolute;
    background: url('/icons/360-arrows.svg') no-repeat center / contain;
    width: 100%;
    height: 3.75rem;
    z-index: 1;
    bottom: 3.75rem;
    pointer-events: none;
  }

  .v360-viewport {
    cursor: grab;
  }

  .v360-image-container {
    touch-action: unset !important;
  }
}
</style>
